// F8 milestones. Appears once per threshold, dismissible, and celebrates only
// the act of tracking (UI plan §2.2) — never weight, never a deficit. There is
// no counterpart for a missed day: a lapse is never mentioned, let alone
// penalised.
import { useState } from "react";
import { useT } from "../lib/i18n";
import { hapticSuccess } from "../lib/haptics";
import { milestoneFor } from "@shared/milestones";
import { Mascot } from "./Mascot";

export function MilestoneCard({ loggedDays }: { loggedDays: number }) {
  const t = useT();
  const reached = milestoneFor(loggedDays);
  const key = reached ? `caloly.milestone_seen_${reached.days}` : "";
  const [dismissed, setDismissed] = useState(() => {
    try { return !reached || localStorage.getItem(key) === "1"; } catch { return true; }
  });

  if (!reached || dismissed) return null;

  function close() {
    try { localStorage.setItem(key, "1"); } catch { /* storage unavailable */ }
    hapticSuccess();
    setDismissed(true);
  }

  return (
    <div className="bg-brand/10 border border-brand/30 rounded-2xl p-3 flex items-center gap-3 animate-rise">
      <Mascot pose="celebrating" size={44} />
      <div className="flex-1 text-sm">
        <div className="font-medium">{t(reached.key)}</div>
        <div className="text-fg-muted text-sm mt-0.5">
          {t("milestone.sub", { n: String(loggedDays) })}
        </div>
      </div>
      <button onClick={close} aria-label={t("common.close")} className="text-fg-faint p-3 -m-2 press">✕</button>
    </div>
  );
}
